import React from 'react';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import CurrentUser from '../CurrentUser';
import ButtonLink from '../../../elements/ButtonLink';

/**
 * Renders an error message and related actions if an error is present.
 *
 * @param {object} props - The props object containing the error.
 * @return {JSX.Element | null} The rendered error message and related actions, or null if no error is present.
 */
function AddWithCodeErrorFlow(props) {
    const { user, error } = props,
        i18n = useI18n();

    if (!error) return null;

    const errorMessage = error.message ?? i18n['label.error'];

    return (
        <div>
            <div
                className='error'
                dangerouslySetInnerHTML={{
                    __html: errorMessage.replace('\n', '<br>'),
                }}></div>

            {user ? (
                <div>
                    <div style={{ padding: '2em 0em', color: '#999' }}>
                        <CurrentUser />
                    </div>
                    <ButtonLink href='/' style={{ backgroundColor: 'white' }}>
                        {i18n['label.go.MyNetworkapp']}
                    </ButtonLink>
                </div>
            ) : error.code_used ? (
                <div>
                    <ButtonLink
                        style={{ backgroundColor: 'white' }}
                        href='/login'>
                        {i18n['label.loginAction']}
                    </ButtonLink>
                </div>
            ) : (
                <div>
                    <ButtonLink href='/' style={{ backgroundColor: 'white' }}>
                        {i18n['label.go.MyNetworkapp']}
                    </ButtonLink>
                </div>
            )}
        </div>
    );
}

export default AddWithCodeErrorFlow;
